import MainNavigationNew from './MainNavigation'

export default MainNavigationNew
